import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import { VDataTable } from 'vuetify/labs/VDataTable';

const customColorTheme = {
    dark: false,
    colors: {
        primary: '#184db4',
        secondary: '#18A6D2',
        tertiary: '#2366E9',
        quaternary: '#333333',
        quinary: '#DFE3E8',
        senary: '#f9fafb',
        septenary: '#757575',
        accent: '#18A6D2',
        anchor: '#18A6D2',
        error: '#E92505',
        success: '#60B403',
        warning: '#FFC203',
        info: '#00B4E2',
    },
};

export default {
    // eslint-disable-next-line no-unused-vars
    create: (theme = {}) => {
        const opts = {
            theme: {
                options: {
                    customProperties: true,
                },
                defaultTheme: 'customColorTheme',
                themes: {
                    customColorTheme,
                },
                icons: {
                    defaultSet: 'mdi',
                    aliases,
                    sets: {
                        mdi,
                    },
                },
            },
            components: {
                ...components,
                VDataTable,
            },
            directives,
        };
        return createVuetify(opts);
    },
};
